import * as THREE from 'three';

/** Parámetros del aluminio anodizado, iguales para todos los colores. */
export const ALU_METALNESS = 0.8;
export const ALU_ROUGHNESS = 0.35;

/**
 * Material de aluminio anodizado para la estructura. Aspecto metálico que refleja
 * el HDRI del entorno. El color (hex sRGB) procede de attributes.json; solo cambia
 * el tinte base, manteniendo metalness/roughness constantes.
 */
export function createAluminumMaterial(colorHex: string): THREE.MeshStandardMaterial {
  const mat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(colorHex),
    metalness: ALU_METALNESS,
    roughness: ALU_ROUGHNESS,
    envMapIntensity: 1.0,
  });
  mat.name = 'aluminum';
  return mat;
}

/** Hormigón para la base de anclaje tipo "Hormigón". */
export function createConcreteMaterial(): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({ color: 0x9a9893, metalness: 0, roughness: 0.95 });
}

/** Acero galvanizado para placas/tornillería de anclaje (tarima) y picas (césped). */
export function createSteelMaterial(): THREE.MeshStandardMaterial {
  return new THREE.MeshStandardMaterial({ color: 0x8a8d91, metalness: 0.8, roughness: 0.35 });
}
